<div class="row animated fadeIn">
    <div class="col-md-12">
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h4 class="mb-0"><a href="javascript:void(0);" routerLink="/project/projectlist"><span
                        class="mdi mdi-arrow-left"></span></a> Edit Project</h4>
        </div>

        <div class="card">
            <div class="card-body">
                <ngb-tab id="tab-selectbyid1" title="Edit Project">
                    <form [formGroup]="registerForm">
                        <div class="form-row">
                            <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                <label for="" class="d-flex justify-content-between align-items-center">Project ID
                                </label>
                                <input class="form-control-plaintext" type="text" formControlName="ProjectId"
                                    readonly />
                            </div>

                            <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                <label for="" class="d-inline-block justify-content-between align-items-center">Project
                                    Name<span class="required ml-1">*</span>
                                </label>
                                <mat-form-field appearance="fill" class="w-100">
                                    <input type="text" placeholder="Project Name"
                                        class="form-control example-no-focus py-0" aria-label="text" matInput
                                        [matAutocomplete]="auto" maxlength="100" formControlName="ProjectName"
                                        (input)="ProSearchFun($event)">
                                    <mat-autocomplete #auto="matAutocomplete" class="w-100">
                                        <mat-option *ngFor="let option of ProNameId | async" [value]="option">
                                            {{option}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <div
                                    *ngIf="registerForm.get('ProjectName').invalid && registerForm.get('ProjectName').errors && (registerForm.get('ProjectName').dirty || registerForm.get('ProjectName').touched) || submitted">
                                    <small class="text-danger"
                                        *ngIf="registerForm.get('ProjectName').hasError('required')">
                                        Project Name is Required
                                    </small>
                                    <small class="text-danger"
                                        *ngIf="registerForm.get('ProjectName').hasError('pattern')">
                                        Project Name is not valid
                                    </small>
                                </div>
                            </div>

                            <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                <label for=""
                                    class="d-inline-block justify-content-between align-items-center">Quotation
                                    Engineer<span class="required ml-1">*</span>
                                </label>
                                <angular2-multiselect formControlName="QuotationEngineer" [data]="quotation"
                                    [(ngModel)]="selectedQuotation" [settings]="dropdownSetting0"
                                    (onSelect)="onQuotationSelect($event)" (onDeSelect)="onQuotationSelect($event)" fixSearchBug></angular2-multiselect>
                                <div
                                    *ngIf="registerForm.get('QuotationEngineer').invalid && registerForm.get('QuotationEngineer').errors && (registerForm.get('QuotationEngineer').dirty || registerForm.get('QuotationEngineer').touched) || submitted">
                                    <small class="text-danger"
                                        *ngIf="registerForm.get('QuotationEngineer').hasError('required')">
                                        Quotation Engineer is Required.
                                    </small>
                                </div>
                            </div>

                            <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                <label for="" class="d-inline-block justify-content-between align-items-center">Sales
                                    Engineer<span class="required ml-1">*</span>
                                </label>
                                <angular2-multiselect formControlName="SalesEngineer" [data]="sales"
                                    [(ngModel)]="selectedSales" [settings]="dropdownSetting1"
                                    (onSelect)="onSalesSelect($event)" fixSearchBug></angular2-multiselect>
                                <div
                                    *ngIf="registerForm.get('SalesEngineer').invalid && registerForm.get('SalesEngineer').errors && (registerForm.get('SalesEngineer').dirty || registerForm.get('SalesEngineer').touched) || submitted">
                                    <small class="text-danger"
                                        *ngIf="registerForm.get('SalesEngineer').hasError('required')">
                                        Sales Engineer is Required.
                                    </small>
                                </div>
                            </div>

                            <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                <label for="" class="d-inline-block justify-content-between align-items-center">Project
                                    Source<span class="required ml-1">*</span>
                                </label>
                                <angular2-multiselect formControlName="ProjectSource" [data]="project"
                                    [(ngModel)]="selectedProject" [settings]="dropdownSetting2"
                                    [ngClass]="{ 'is-invalid': submitted && f.ProjectSource.errors }"
                                    (onSelect)="onProjectSelect($event)" fixSearchBug>
                                </angular2-multiselect>
                                <div
                                    *ngIf="registerForm.get('ProjectSource').invalid && registerForm.get('ProjectSource').errors && (registerForm.get('ProjectSource').dirty || registerForm.get('ProjectSource').touched) || submitted">
                                    <small class="text-danger"
                                        *ngIf="registerForm.get('ProjectSource').hasError('required')">
                                        Project Source Engineer is Required.
                                    </small>
                                </div>
                            </div>

                            <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                <label for=""
                                    class="d-inline-block justify-content-between align-items-center">Territory
                                </label>
                                <input class="form-control-plaintext" type="text" formControlName="Territory"
                                    readonly />
                            </div>

                            <div class="form-group col-lg-3 col-md-6 col-sm-12">
                                <label for="" class="d-inline-block justify-content-between align-items-center">Project
                                    Status<span class="required ml-1">*</span>
                                </label>
                                <angular2-multiselect formControlName="ProjectStatus" [data]="status"
                                    [(ngModel)]="selectedStatus" [settings]="dropdownSetting4"
                                    [ngClass]="{ 'is-invalid': submitted && f.ProjectStatus.errors }"
                                    (onSelect)="onStatusSelect($event)" fixSearchBug>
                                </angular2-multiselect>
                                <div
                                    *ngIf="registerForm.get('ProjectStatus').invalid && registerForm.get('ProjectStatus').errors && (registerForm.get('ProjectStatus').dirty || registerForm.get('ProjectStatus').touched) || submitted">
                                    <small class="text-danger"
                                        *ngIf="registerForm.get('ProjectStatus').hasError('required')">
                                        Project Status is Required.
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="row mt-2">
                            <div class="col-lg-12">
                                <a href="javascript:void(0);" type="submit" class="btn btn-info"
                                    (click)="onSubmit()">Save</a>

                                <a href="javascript:void(0);" class="btn btn-danger ml-2"
                                    routerLink="/project/projectlist">Cancel</a>
                            </div>
                        </div>

                    </form>
                    <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
                </ngb-tab>
            </div>
        </div>
    </div>
</div>